import React from 'react';
import { Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/bundle';

/**
 * @param imagePlatform - thư mục ảnh hướng dẫn (mặc định = platform). ShopeeFood
 *   chưa có bộ ảnh riêng nên tạm mượn ảnh Shopee.
 * @param title - dòng tiêu đề thứ 2 (mặc định "MUA SẮM HOÀN TIỀN").
 */
function CashBackGuide({
    fromColorBg,
    toColorBg,
    platform,
    borderColor,
    isLinkMode,
    imagePlatform,
    title,
}) {
    const slideList2 = {
        shopee: [
            {
                step: 1,
                content: (
                    <p>
                        Tại trang sản phẩm trên Shopee, bấm vào{' '}
                        <strong>Mũi tên</strong> ở góc phía bên phải
                    </p>
                ),
            },
            {
                step: 2,
                content: (
                    <p>
                        Ở hộp thoại mở lên, chọn{' '}
                        <strong>Sao chép đường dẫn</strong>
                    </p>
                ),
            },
            {
                step: 3,
                content: (
                    <p>
                        Quay về Longhousee <strong>Dán link</strong> vừa sao
                        chép vào <strong>Khung dán link</strong>
                    </p>
                ),
            },
            {
                step: 4,
                content: (
                    <p>
                        Nhấn <strong>Mua ngay</strong> để mở app Shopee và được
                        hoàn tiền
                    </p>
                ),
            },
        ],
        lazada: [
            {
                step: 1,
                content: (
                    <p>
                        Tại trang sản phẩm trên Lazada, bấm vào{' '}
                        <strong>Mũi tên</strong> ở góc phía bên phải
                    </p>
                ),
            },
            {
                step: 2,
                content: (
                    <p>
                        Ở hộp thoại mở lên, chọn{' '}
                        <strong>Sao chép đường dẫn</strong>
                    </p>
                ),
            },
            {
                step: 3,
                content: (
                    <p>
                        Quay về Longhousee <strong>Dán link</strong> vừa sao
                        chép vào <strong>Khung dán link</strong>
                    </p>
                ),
            },
            {
                step: 4,
                content: (
                    <p>
                        Nhấn <strong>Mua ngay</strong> để mở app Lazada và được
                        hoàn tiền
                    </p>
                ),
            },
        ],
        tiktok: [
            {
                step: 1,
                content: (
                    <p>
                        Tại trang sản phẩm trên Tiktok, bấm vào{' '}
                        <strong>Mũi tên</strong> ở góc phía bên phải và nhấn{' '}
                        <strong>Sao chép liên kết</strong>
                    </p>
                ),
            },
            {
                step: 2,
                content: (
                    <p>
                        Quay về Longhousee <strong>Dán link</strong> vừa sao
                        chép vào <strong>Khung dán link</strong>
                    </p>
                ),
            },
            {
                step: 3,
                content: (
                    <p>
                        Chọn <strong>Phần trưng bày</strong> trên kênh tiktok
                        Săn sale cùng Longhousee và tìm <strong>Mua</strong> sản
                        phẩm của bạn
                    </p>
                ),
            },
            {
                step: 4,
                content: (
                    <p>
                        Sao chép <strong>Số đơn hàng</strong> đã đặt sau đó quay
                        trở lại trang nhấn <strong>Tìm đơn</strong>
                    </p>
                ),
            },
        ],
        shopeefood: [
            {
                step: 1,
                content: (
                    <p>
                        Mở app/web <strong>ShopeeFood</strong>, chọn quán hoặc
                        món bạn muốn đặt
                    </p>
                ),
            },
            {
                step: 2,
                content: (
                    <p>
                        Bấm <strong>Chia sẻ</strong> →{' '}
                        <strong>Sao chép liên kết</strong> của quán/món
                    </p>
                ),
            },
            {
                step: 3,
                content: (
                    <p>
                        Quay lại Longhousee, <strong>dán link</strong> vào khung
                        phía trên
                    </p>
                ),
            },
            {
                step: 4,
                content: (
                    <p>
                        Nhấn <strong>Đặt món ngay</strong> và hoàn tất đơn để
                        được hoàn tiền
                    </p>
                ),
            },
        ],
    };
    // Link mode (mua qua affiliate link): ẩn bước trưng bày (3 & 4) — chỉ giữ bước
    // copy link + dán link mua. Showcase mode: hiện đủ 4 bước.
    const allSlides = slideList2[platform || 'shopee'];
    const visibleSlides =
        platform === 'tiktok' && isLinkMode ? allSlides.slice(0, 2) : allSlides;
    return (
        <div className="flex flex-col gap-3">
            <div className="flex gap-1 justify-start items-center">
                <div
                    className={`h-10 aspect-square bg-gradient-to-br p-2 ${
                        fromColorBg || 'from-orange-500'
                    } ${toColorBg || 'to-orange-600'} rounded-full`}
                >
                    <img
                        src="img/ui/information_white.svg"
                        alt="infomation"
                        className="w-full h-full object-cover"
                    />
                </div>
                <div className="flex flex-col text-sm text-content-2">
                    <span className="font-bold">{`${visibleSlides.length} bước`}</span>
                    <span className="font-bold">
                        {title || 'MUA SẮM HOÀN TIỀN'}
                    </span>
                </div>
            </div>
            <div>
                <Swiper
                    modules={[Autoplay]}
                    className="h-full rounded-lg overflow-hidden"
                    spaceBetween={4}
                    slidesPerView={2.1}
                    autoplay
                    pagination={{
                        clickable: true,
                        renderBullet: function (index, className) {
                            return (
                                '<span class="' +
                                className +
                                ' custom-pagination-bullet"></span>'
                            );
                        },
                    }}
                >
                    {visibleSlides.map((el, index) => (
                        <SwiperSlide key={index} className="">
                            <div>
                                <div
                                    className={`w-full bg-red-400 border rounded-lg overflow-hidden ${
                                        borderColor || 'border-primary-600'
                                    }`}
                                >
                                    <img
                                        src={`img/ui/guide/${
                                            imagePlatform ||
                                            platform ||
                                            'tiktok'
                                        }/${el.step}.png`}
                                        alt="guide"
                                    />
                                </div>
                                <div className="text-xs md:text-sm">
                                    <span className="font-bold">{`Bước ${el.step}`}</span>
                                    <p>{el.content}</p>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
}

export default CashBackGuide;
